<template>
  <div class="main">
    <!-- 中间 -->
    <div id="user" class="app-container">
      <!-- <div class="leftList">
        <div class="user-center__R8SKINS-logo">
          <div
            class="picture-container user-center__R8SKINS-logo__picture"
            style="padding-top: 13.0169%; width: 100%"
          >
            <div
              class="picture"
              style="
                background-size: contain;
              "
            ></div>
          </div>
        </div>
        <ul
          class="Menu ivu-menu ivu-menu-light ivu-menu-vertical"
          style="width: auto"
        >
          <li class="ivu-menu-item  ivu-menu-item-selected">
            <a
              href="/#/userinfo"
              class="router-link-exact-active router-link-active"
              aria-current="page"
              ><i
                class="iconfont "
                style="font-size: 19px"
              >&#xe65a;</i
              >个人中心
            </a>
          </li>
          <li class="ivu-menu-item  ivu-menu-item-selected">
            <a
              href="/#/recaption"
              class="router-link-exact-active router-link-active"
              aria-current="page"
              ><i
                class="iconfont"
                style="font-size: 19px"
              >&#xe61d;</i
              >我的库存
            </a>
          </li>
          <li class="ivu-menu-item ivu-menu-item-active ivu-menu-item-selected">
            <a
              href="/#/agency"
              class="router-link-exact-active router-link-active"
              aria-current="page"
              ><i
                class="iconfont"
                style="font-size: 19px"
              >&#xe61a;</i
              >合作中心
            </a>
          </li>
          <li class="ivu-menu-item ">
            <a href="/#/record" class=""
              ><i
                class="iconfont"
                style="font-size: 19px"
              >&#xe61e;</i>
              充值记录
            </a>
          </li>
        </ul>
      </div> -->
      <leftList></leftList>

      <div class="rightView">
        <div class="recaptionBox">
          <div class="recaptionBox_bg">
            <div class="recaptionBox__title">
              <div class="recaptionBox__title__left">
                <div class="recaptionBox__title__left__stock">代理信息</div>
                <div class="recaptionBox__title__left__test"></div>
              </div>
            </div>
            <div class="agency-content">
              <div class="wrapper">
                <div class="link">
                  <div style="width: 75%">
                    <p>您的推广链接：</p>
                    <div class="inputbox">
                      <input type="text" id="success_form_input2" readonly="readonly" v-model="invitationlink"/>
                    </div>
                  </div>
                  <div ref="copy2" data-clipboard-action="copy" data-clipboard-target="#success_form_input2" @click="copyLink2" class="copy"><p>复 制</p></div>
                </div>
                <div class="link">
                  <div style="width: 75%" class="inputboxs">
                    <p>您的推荐码：</p>
                    <div class="inputbox">
                      <input type="text" id="success_form_input" readonly="readonly" v-model="invitationCode"/>
                    </div>
                  </div>
                  <div ref="copy" data-clipboard-action="copy"  data-clipboard-target="#success_form_input" @click="open" class="copy"><p>修 改</p></div>
                  <div ref="copy" data-clipboard-action="copy" data-clipboard-target="#success_form_input" @click="copyLink" class="copy"><p>复 制</p></div>
                </div>
              </div>
              <div class="extension">
                <div class="head">
                  <div>返利百分比</div>
                  <div>总推荐人数</div>
                  <div>总充值金额</div>
                  <div>总收益</div>
                </div>
                <div class="extensionBody">
                  <div>{{subinfo.subPct}}%</div>
                  <div>{{subinfo.subCount}}</div>
                  <div>{{sublist.allSCoin}}</div>
                  <div>{{sublist.allCoin}}</div>
                </div>
              </div>
              <div class="partnerInfo">
                <div class="content">
                  <div class="wrapper">
                    <div class="item">
                      <img src="../assets/img/agency/hz1.png" alt="" />
                      <h2>永久绑定</h2>
                      <div class="p">
                        <p>您邀请的合作伙伴将与您进行永久绑定！</p>
                        <p>
                          他的每一次充值，都将给他自己带来3%的额外加成，同时为您增加对应级别比例的抽成。
                        </p>
                        <p>
                          伙伴越多，对方充值时您的收益就越高，您还在等什么呢？
                        </p>
                      </div>
                    </div>
                    <div class="item">
                      <img
                        src="data:image/png;base64,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"
                        alt=""
                      />
                      <h2>温馨提示</h2>
                      <div class="p">
                        <p>您需要邀请至少20个伙伴才能提取收益至账户余额。</p>
                        <p style="opacity: 0;">占位符</p>
                      </div>
                    </div>
                    <div class="item">
                      <img src="../assets/img/agency/hz3.png" alt="" />
                      <h2>人人皆可是伙伴</h2>
                      <div class="p">
                        <p>
                          如果您是游戏主播、B站up主、QQ群主等大佬，请添加商务咨询QQ：{{this.$store.state.webdata.qq}}。也欢迎进入我们的官方客服群：官方群：{{this.$store.state.webdata.qq_qun}}。
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="partnerNotice">
                <div style="width: 200%" class="partnerNotices">
                  <div class="partnerLevels">
                    <div class="levelList">
                      <div class="titleContent">
                        <div class="info">
                          <img src="../assets/img/freeBox/titleI.png" alt="" />
                          <p>推广级别</p>
                        </div>
                      </div>
                      <div class="listTable">
                        <div class="listHead">
                          <div>您的推广级别</div>
                          <div>到达下一个级别</div>
                          <div>您的抽成比例</div>
                          <div>被邀用户充值加成</div>
                        </div>
                        <!-- <div>
                          <div class="listBody">
                            <div>1</div>
                            <div>2000Coins</div>
                            <div>1%</div>
                            <div>+0.5%</div>
                          </div>
                        </div> -->
                        <div v-for="(item,index) in gradedata" :key="index">
                          <div class="listBody">
                            <div>{{item.level}}</div>
                            <div>{{item.coin}}</div>
                            <div>{{item.sub}}</div>
                            <div>{{item.paySub}}%</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="partnerLevels">
                    <div class="levelList">
                      <div class="titleContent">
                        <div class="info">
                          <img src="../assets/img/freeBox/titleI.png" alt="" />
                          <p>推广记录</p>
                        </div>
                      </div>
                      <div class="listTable">
                        <div class="listHead">
                          <div>推广用户</div>
                          <div>推广收益</div>
                          <div>充值金额</div>
                        </div>
                        <div>
                          <div class="listBody" v-for="(items,indexs) in sublist.data" :key="indexs">
                            <div>{{items.username}}</div>
                            <div>{{items.coin}}</div>
                            <div>{{items.sCoin}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="partnerTips">
                  <div>
                    <div>
                      <div class="titleContent">
                        <div class="info">
                          <img src="../assets/img/freeBox/titleI.png" alt="" />
                          <p>合作建议</p>
                        </div>
                      </div>
                      <div class="tips">
                        <div>
                          <div class="faqItem" @click="faqItem2">
                            <div class="cardTop">
                              <div class="cardLeft"><span>合作建议</span></div>
                              <div class="cardRight">
                                <span class="arrow"></span>
                              </div>
                            </div>
                            <div class="cardClose" :class="{'cardOpen':active2}">
                              <div>
                                <p>
                                  <span style="font-size: 16px"
                                    ><span style="color: rgb(255, 255, 255)"
                                      >给您的推广链接打广告</span
                                    ></span
                                  >
                                </p>
                                <p></p>
                                <p>
                                  <span style="font-size: 14px"
                                    >您可以将你的推广链接或者推广代码放到您常去网站的评论区。<br />
                                    越多人访问您的链接，您就会获得更多的推广账户余额，这意味着您可以免费获得更多昂贵的饰品。</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="titleContent">
                        <div class="info">
                          <img src="../assets/img/freeBox/titleI.png" alt="" />
                          <p>常问问题</p>
                        </div>
                      </div>
                      <div class="faq">
                        <div>
                          <div class="faqItem" @click="faqItem1">
                            <div class="cardTop">
                              <div class="cardLeft">
                                <span>推广合作答疑</span>
                              </div>
                              <div class="cardRight">
                                <span class="arrow"></span>
                              </div>
                            </div>
                            <div class="cardClose" :class="{'cardOpen':active1}">
                              <div>
                                <p>
                                  <span style="font-size: 14px"
                                    >&ZeroWidthSpace;&ZeroWidthSpace;&ZeroWidthSpace;&ZeroWidthSpace;&ZeroWidthSpace;</span
                                  >
                                </p>
                                <p>
                                  <span style="color: rgb(255, 255, 255)"
                                    ><span style="font-size: 16px"
                                      >这个推广合作系统是怎么回事?</span
                                    ></span
                                  >
                                </p>
                                <p></p>
                                <p>
                                  <span style="font-size: 14px"
                                    >作为CXSKINS的推广合作伙伴，您将会得到推广链接和推广代码。<br />
                                    每一次有人使用您的推广链接或代码进行充值，您都可以按照充值金额的一定百分比获得抽成。</span
                                  >
                                </p>
                                <p></p>
                                <p>
                                  <span style="color: rgb(255, 255, 255)"
                                    ><span style="font-size: 16px"
                                      >我可以赚多少?</span
                                    ></span
                                  >
                                </p>
                                <p></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 红包 -->
    <Redenvelopes></Redenvelopes>
  </div>
</template>

<script>
import Redenvelopes from "../components/Redenvelopes";
import leftList from "../components/userleftList"
// import Clipboard from 'clipboard';
export default {
  components: {
     Redenvelopes,
     leftList,
  },
  data() {
    return {
      active1:false,//合作切换
      active2:false,//合作切换
      invitationCode:'',//邀请码
      copyBtn:null,//复制邀请码
      invitationlink:'',//邀请链接
      copyBtn2:null,//复制链接
      sublist:"",//页面信息1
      subinfo:"",//页面信息2
      gradedata:'',//等级信息
      gradedatas:[],

    };
  },
  methods: {
    //合作
    faqItem1() {
      this.active1 = !this.active1
    },
    faqItem2() {
      this.active2 = !this.active2
    },
    // 红包
    redPrize(){
      document.getElementsByClassName('ivu-modal')[0].style.display="block";
      document.getElementById('isquan').classList.add("backghui")
      
    },
    //修改邀请码
    open(){
      this.$prompt('请输入要修改的推荐码:', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9,A-Z,a-z]{5,8}$/,
        inputErrorMessage: '推荐码格式不正确(5-8位)'
      }).then(({ value }) => {
        this.$axios({
          url:'sub/set/code',
          method:"post",
          data:{
            code:value
          }
          }).then (res => {
            if(res.data.status == 200){ 
              this.$message({
                type: 'success',
                showClose: true,
                message: res.data.msg
              });
              this.invitationCode = value
              this.invitationlink = 'https://www.cxskins.com/?code=' + value
            }else{
              this.$message({
                type: 'error',
                showClose: true,
                message: res.data.msg
              });
            }
          })
        
      }).catch(() => {
        this.$message({
          type: 'info',
          showClose: true,
          message: '取消'
        });       
      });
    },
    //复制邀请码
    copyLink() {
      let _this = this;
      let clipboard = _this.copyBtn;
      clipboard.on('success', function() {
          _this.$message({
              message: '复制成功！',
              type: 'success',
              showClose: true,
          });
      });
      clipboard.on('error', function() {
          _this.$message({
              message: '复制失败，请手动选择复制！',
              type: 'error',
              showClose: true,
          });
      });
    },
    //复制邀请码
    copyLink2() {
      let _this = this;
      let clipboard = _this.copyBtn2;
      clipboard.on('success', function() {
          _this.$message({
              message: '复制成功！',
              type: 'success',
              showClose: true,
          });
      });
      clipboard.on('error', function() {
          _this.$message({
              message: '复制失败，请手动选择复制！',
              type: 'error',
              showClose: true,
          });
      });
    },
    //获取页面数据
    getsublist(){
      this.$axios({
        url:'sub/bill/list',
        method:'post',
      }).then( res => {
        if(res.data.status == 200){
          this.sublist = res.data.data
        }
      })
    },
    //获取页面数据2
    getsublist2(){
      this.$axios({
        url:'sub/info ',
        method:'post',
      }).then( res => {
        if(res.data.status == 200){
          this.subinfo = res.data.data
          this.invitationCode = res.data.data.code
          this.invitationlink = 'https://www.cxskins.com/?code=' + res.data.data.code
        }
      })
    },
    //获取等级信息
    getsub(){
      this.$axios({
        url:'sub/get/list',
        method:'post',
      }).then (res => {
        
        // let nextCoint = [];
        // res.data.forEach(value => {
        //   console.log(value["coin"]);
        //   nextCoin.push(value.coin);
        // });
        // console.log(nextCoint);
        // let a = 0;
        // res.data.forEach(value => {
        //   if(a != res.data.length){
        //     res.data["coin"] = nextCoint[a+1];
        //   }else{
        //     res.data["coin"] = "Na/Na";
        //   }
        //   a++;
        // });
        this.gradedata = res.data
        for(let i = 0;i < this.gradedata.length;i++){
          this.gradedatas.push(this.gradedata[i].coin)
        }
        this.gradedatas.shift(); 
        this.gradedatas.push('NAN'); 
        for(let j = 0;j < this.gradedatas.length;j++){
          this.gradedata[j].coin = this.gradedatas[j]
        }
      })
    },
    //登录
    handleZhu() {
      document.getElementsByClassName("form-wnd")[0].classList.add("active");
      document.getElementsByClassName("popup-bg")[0].classList.add("active");
      document.getElementsByClassName("switch-block")[0].classList.add("active");
      document.getElementsByClassName("switch-block")[1].classList.remove("active");
      document.getElementsByClassName("button")[0].classList.add("active");
      document.getElementsByClassName("button")[1].classList.remove("active");
      this.isBar = false;
      this.password=''
    },
  },
  mounted() {
    if(!localStorage.getItem("token")){
      this.$message({
        showClose: true,
        message: '请先登录'
      });
      this.$router.push('/')
      //提示登录框
      setTimeout( ()=> {
        this.handleZhu()
      },300)
    }
    this.copyBtn = new this.clipboard(this.$refs.copy);
    this.copyBtn2 = new this.clipboard(this.$refs.copy2);
    this.getsublist()
    this.getsublist2()
    this.getsub()
  },
};
</script>

<style scoped lang='less'>
* :not(input,textarea) { 
    -webkit-touch-callout: text !important; 
    -webkit-user-select: text !important; 
}
@import url("../assets/csscopy/user/share.css");
@import url("../assets/csscopy/user/agency.css");
.picture{
  background-image: url("../assets/img/logo.6a88e67b.png") !important;
}
@media screen and (max-width: 800px) {
  .leftList{
    width: 20% !important;
  }
  .rightView{
    display:block !important;
    width: 80%;
  }
  .recaptionBox_bg{
    padding: 20px 10px !important;
  }
  .wrapper{
    display: block !important;
    .link{
      width: 100% !important;
    }
  }
  .inputboxs{
    width: 65% !important;
  }
  .content{
    height: 100% !important;
    .wrapper{
      display: block !important;
      .item{
        width: 100% !important;
      }
    }
  }
  .partnerNotice{
    display: block !important;
    width: 100% !important;
  }
  .partnerNotices{
    width: 100% !important;
  }
  .partnerTips{
    width: 100% !important;
    margin-left:0 !important;
  }
}
</style>
<style>
  @media screen and (max-width: 800px) {
    .el-message-box{
      width: 95% ;
    }
  }
</style>